import React, { memo } from 'react';
import { FiTrash2, FiEye, FiChevronUp, FiChevronDown } from 'react-icons/fi';

const PurchaseTable = memo(({
    paginatedPurchaseGroups,
    sortBy,
    sortDirection,
    handleSort,
    handleOpenDetailsDialog,
    handleOpenDeleteDialog
}) => {
    const renderSortIcon = (column) => {
        if (sortBy !== column) {
            return <FiChevronDown className="ms-1 text-muted" size={14} />;
        }
        return sortDirection === 'asc' ? 
            <FiChevronUp className="ms-1" size={14} /> : 
            <FiChevronDown className="ms-1" size={14} />;
    };

    return (
        <div className="card">
            <div className="card-body p-0">
                <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 250px)' }}>
                    <table className="table table-hover mb-0">
                        <thead className="sticky-top bg-white">
                            <tr>
                                <th 
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleSort('invoiceNumber')}
                                >
                                    Invoice # {renderSortIcon('invoiceNumber')}
                                </th>
                                <th 
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleSort('date')}
                                >
                                    Date {renderSortIcon('date')}
                                </th>
                                <th 
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleSort('supplierName')}
                                >
                                    Supplier {renderSortIcon('supplierName')}
                                </th>
                                <th 
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleSort('totalAmount')}
                                >
                                    Total Amount {renderSortIcon('totalAmount')}
                                </th>
                                <th 
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleSort('items')}
                                >
                                    Items {renderSortIcon('items')}
                                </th>
                                <th 
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleSort('status')}
                                >
                                    Status {renderSortIcon('status')}
                                </th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedPurchaseGroups.map((group) => (
                                <tr key={group.id}>
                                    <td className="fw-semibold">{group.invoiceNumber || '-'}</td>
                                    <td>
                                        {group.date ? new Date(group.date).toLocaleDateString('en-US', {
                                            year: 'numeric',
                                            month: 'short',
                                            day: 'numeric'
                                        }) : '-'}
                                    </td>
                                    <td className="fw-semibold">{group.supplierName || 'Unknown'}</td>
                                    <td className="fw-semibold text-success">
                                        ${Number(group.totalAmount || 0).toFixed(2)}
                                    </td>
                                    <td>
                                        <span className="badge bg-primary">
                                            {group.items || 0} items
                                        </span>
                                    </td>
                                    <td>
                                        <span className={`badge bg-${
                                            group.status === 'completed' ? 'success' : 
                                            group.status === 'pending' ? 'warning' : 
                                            'secondary'
                                        }`}>
                                            {group.status || 'pending'}
                                        </span>
                                    </td>
                                    <td>
                                        <button
                                            className="btn btn-sm btn-outline-primary me-2"
                                            onClick={() => handleOpenDetailsDialog(group)}
                                            title="View Details"
                                        >
                                            <FiEye />
                                        </button>
                                        <button
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() => handleOpenDeleteDialog(group)}
                                            title="Delete"
                                        >
                                            <FiTrash2 />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {paginatedPurchaseGroups.length === 0 && (
                    <div className="text-center py-5">
                        <i className="bi bi-inbox" style={{ fontSize: '3rem', color: '#ccc' }}></i>
                        <p className="text-muted mt-3">No purchases found</p>
                    </div>
                )}
            </div>
        </div>
    );
});

PurchaseTable.displayName = 'PurchaseTable';

export default PurchaseTable;
